export function verificationLoginUrl(email: string | null, redirect: string | null): string {
  const params = new URLSearchParams();
  if (email) {
    params.set('email', email);
    params.set('step', 'password');
  }
  if (redirect?.startsWith('/') && !redirect.startsWith('//') && !redirect.includes('\\')) {
    params.set('redirect', redirect);
  }
  return `/login${params.size ? `?${params}` : ''}`;
}
